import apolloClient, { ApolloProvider } from 'Utils/apolloClient'
import SitesByTypeDropdown from './SitesByTypeDropdown'

const Wrapper = () => {
  const container = document.getElementById('react-data-container')
  const { id, slug, token } = container.dataset
  window.roverData = { campgroundId: id, slug, token }

  return (
    <ApolloProvider client={apolloClient}>
      <SitesByTypeDropdown slug={slug} />
    </ApolloProvider>
  )
}

export default Wrapper
